import React, { useState, useEffect, useContext } from "react";
import { Container } from "react-bootstrap";
import DistributorSidebar from "../../components/distributor/distributorSidebar/DistributorSidebar";
import { Menu, Bell, Search } from "lucide-react";
import "../../assets/styles/distributor/DistributorMasterLayout.css";
import AppContext from "../../context/AppContext";

const DistributorMasterLayout = ({ children }) => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const { storeLoggedInDistributor } = useContext(AppContext);

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 992) {
        setIsSidebarCollapsed(false);
      }
    };

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    // console.log("log from layout",  JSON.parse(localStorage.getItem("loggedInDistributor")) )
    storeLoggedInDistributor(
      JSON.parse(localStorage.getItem("loggedInDistributor"))
    );
  }, []);

  // Toggle sidebar collapse
  const toggleSidebar = () => {
    if (window.innerWidth >= 992) {
      setIsSidebarCollapsed(!isSidebarCollapsed);
    }
  };

  // Toggle mobile sidebar
  const toggleMobileSidebar = () => {
    setIsMobileSidebarOpen(!isMobileSidebarOpen);
  };

  // Close mobile sidebar when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isMobileSidebarOpen &&
        window.innerWidth < 992 &&
        !event.target.closest(".distributorsidebar-wrapper") &&
        !event.target.closest(".distributormasterlayout-mobile-menu-btn")
      ) {
        setIsMobileSidebarOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isMobileSidebarOpen]);

  return (
    <div className="distributormasterlayout-wrapper">
      {/* Sidebar */}
      <div
        className={isMobileSidebarOpen ? "distributorsidebar-mobile-open" : ""}
      >
        <DistributorSidebar
          isCollapsed={isSidebarCollapsed}
          toggleSidebar={toggleSidebar}
        />
      </div>

      {/* Mobile Overlay */}
      {isMobileSidebarOpen && (
        <div
          className="distributormasterlayout-mobile-overlay"
          onClick={toggleMobileSidebar}
        ></div>
      )}

      {/* Main Content Area */}
      <div
        className={`distributormasterlayout-main ${
          isSidebarCollapsed ? "distributormasterlayout-main-expanded" : ""
        }`}
      >
        {/* Top Header */}
        <header className="distributormasterlayout-header">
          <Container fluid>
            <div className="distributormasterlayout-header-content">
              {/* Left Section */}
              <div className="distributormasterlayout-header-left">
                <button
                  className="distributormasterlayout-mobile-menu-btn"
                  onClick={toggleMobileSidebar}
                  aria-label="Toggle menu"
                >
                  <Menu size={24} />
                </button>

                {/* Search Bar - Desktop */}
                <div className="distributormasterlayout-search-wrapper">
                  <Search
                    className="distributormasterlayout-search-icon"
                    size={20}
                  />
                  <input
                    type="text"
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="distributormasterlayout-search-input"
                  />
                </div>
              </div>

              {/* Right Section */}
              <div className="distributormasterlayout-header-right">
                {/* Notification Button */}
                <button className="distributormasterlayout-notification-btn">
                  <Bell size={20} />
                  <span className="distributormasterlayout-notification-badge">
                    3
                  </span>
                </button>

                {/* User Profile */}
                <div className="distributormasterlayout-user-profile">
                  <div className="distributormasterlayout-user-avatar">
                    <span>D</span>
                  </div>
                  <div className="distributormasterlayout-user-info">
                    <span className="distributormasterlayout-user-name">
                      Distributor
                    </span>
                    <span className="distributormasterlayout-user-role">
                      Ahmad Dairy
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </header>

        {/* Page Content */}
        <main className="distributormasterlayout-content">
          <Container fluid>{children}</Container>
        </main>

        {/* Footer */}
        <footer className="distributormasterlayout-footer">
          <Container fluid>
            <div className="distributormasterlayout-footer-content">
              <p className="distributormasterlayout-footer-text">
                © 2026 MilkyWay. All rights reserved.
              </p>
              <div className="distributormasterlayout-footer-links">
                <a
                  href="#privacy"
                  className="distributormasterlayout-footer-link"
                >
                  Privacy Policy
                </a>
                <a
                  href="#terms"
                  className="distributormasterlayout-footer-link"
                >
                  Terms of Service
                </a>
                <a
                  href="#support"
                  className="distributormasterlayout-footer-link"
                >
                  Support
                </a>
              </div>
            </div>
          </Container>
        </footer>
      </div>
    </div>
  );
};

export default DistributorMasterLayout;
